import React, { useEffect, useState } from 'react';
import ListUsers from '../../Component/ManageUser/list';
import Form from '../../Component/ManageUser/form';
import Modal from '../../Component/Common/Modal';
import { subUserCreate, subUserList, subUserUpdate } from '../../action/auth';
import { toast } from 'react-toastify';
import Loader from '../../Component/Common/Loader';

const ManageUser = () => {

    const [showLoader, setShowLoader] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showAddModal, setShowAddModal] = useState(false);
    const [currentPage, setCurrentPage] = useState(1); // FIXED: Start with page 1
    const [data, setData] = useState([]);
    const [selectedUser, setSelectedUser] = useState(null); // NEW: Track selected user

    useEffect(() => {
        fetchUsers();
    }, [currentPage]);

    const fetchUsers = () => {
        setShowLoader(true);
        subUserList({ page: currentPage, limit: 10 }) // FIXED: Pass page & limit
            .then((res) => {
                if (res.status) {
                    setData(res.result);
                }
            })
            .catch((error) => {
                toast.error(error.message || "Failed to fetch users");
            })
            .finally(() => {
                setShowLoader(false);
            });
    };

    const onAddNewUser = (userData) => {
        setShowLoader(true);
        subUserCreate(userData)
            .then((res) => {
                if (res.status) {
                    toast.success(res.result.message);
                    fetchUsers(); // Refresh user list
                    setShowAddModal(false);
                } else {
                    toast.error(res.result.message);
                }
            })
            .finally(() => {
                setShowLoader(false);
            });
    };

    const onEditUser = (userData) => {
        setShowLoader(true);
        subUserUpdate(userData)
            .then((res) => {
                if (res.status) {
                    toast.success(res.result.message);
                    fetchUsers(); 
                    setShowEditModal(false);
                } else {
                    toast.error(res.result.message);
                }
            })
            .finally(() => {
                setShowLoader(false);
            });
    };

    return (
        <React.Fragment>

            {showLoader && <Loader />}
            {/* Add User Modal */}
            <Modal
                isOpen={showAddModal}
                header="Add New User"
                onClose={() => setShowAddModal(false)} // FIXED: Use function
            >
                <Form onSubmit={onAddNewUser}
                    onClose={() => setShowAddModal(false)}
                />
            </Modal>

            {/* Edit User Modal */}
            <Modal
                isOpen={showEditModal}
                header="Edit User"
                onClose={() => setShowEditModal(false)} // FIXED: Use function
            >
                <Form onSubmit={onEditUser} initialValues={selectedUser}
                    onClose={() => setShowEditModal(false)}
                />
            </Modal>

            {/* User List with Pagination */}
            {data && <ListUsers
                data={data}
                setShowAddModal={() => setShowAddModal(true)}
                onEdit={(user) => {
                    setSelectedUser(user);
                    setShowEditModal(true);
                }}
                setCurrentPage={setCurrentPage}
                currentPage={currentPage}
            />}
        </React.Fragment>
    );
};

export default ManageUser;
